// utils/resultPresentation.ts

export interface ResultPresentation {
  label: string;
  colorScheme: string;
  message: string;
}

// Maps the objective pass/fail + percentage into encouraging, practice-oriented
// language. The underlying has_passed / percentage values from the backend are
// NEVER altered here -- only how they're communicated to the student.
export const getResultPresentation = (
  hasPassed: boolean,
  percentage: number
): ResultPresentation => {
  if (hasPassed) {
    return {
      label: "Great Work",
      colorScheme: "green",
      message:
        percentage >= 90
          ? "Excellent! You've mastered this material."
          : "You're right on track — keep this up.",
    };
  }

  if (percentage >= 50) {
    return {
      label: "Keep Practising",
      colorScheme: "orange",
      message: "You're getting close — a bit more practice and you'll get there.",
    };
  }

  return {
    label: "Keep Practising",
    colorScheme: "orange",
    message: "This is a good area to spend more time on. Every attempt helps you improve.",
  };
};